<template>
  <div class="index">
    <div class="project-explain">
      <div class="project-explain-box">
        <div class="box-top">
          <div class="top-title">{{ data.DKBT }}</div>
          <div class="top-content">{{ data.DYBFSM }}</div>
        </div>
        <div class="box-content">
          <div class="content-title">{{ data.DEBFSMBT }}</div>
          <div class="content-wrp">
            <div class="content" v-for="(item, i) in data.cxTable" :key="item.id">
              {{ (i+1) + '、' }}{{ item.value }}
            </div>
          </div>
          <div class="tips">
            <van-icon name="warning-o" />
            {{ data.DSBFSM }}
          </div>
        </div>
        <div class="box-footer">
          <van-button
            :class="checked ? 'btn select-btn' : 'btn'"
            block
            @click="appointStart"
            >下一步</van-button
          >
          <appoint-checkbox class="checkbox" v-model="checked">{{ data.GXKWZ }}</appoint-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appointCheckbox from '@/components/ProjectAppoint/appoint-checkbox'
import { mapGetters } from 'vuex'
export default {
  components: {
    appointCheckbox
  },
  props: {},
  data() {
    return {
      data: {},
      checked: false,
    };
  },
  watch: {},
  computed: {
    ...mapGetters('opinion', ['getOpinionData']),
  },
  methods: {
    appointStart() {
      if (this.checked) {
        this.$parent.curData = this.$parent.allData[this.$parent.pageIndex+1]
        this.$router.push({
          name: 'OpinionPublishProject'
          // path: '/opinion-publish-detail/project'
        })
      }
    }
  },
  created() {
    if(this.getOpinionData(0).length>0) this.data = this.getOpinionData(0)[0].data
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.project-explain {
  height: 100vh;
  background: #ffffff;
  .project-explain-box {
    background: #ffffff;
    .box-top {
      padding: 0px 16px;
      .top-title {
        text-align: center;
        padding-top: 30px;
        font-size: 21px;
        font-weight: bold;
        color: #333333;
      }
      .top-content {
        font-size: 14px;
        font-weight: 500;
        color: #404040;
        padding: 30px 0px;
      }
    }
    .box-content {
      padding: 0px 16px;
      .content-title {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
      }
      .content-wrp {
        background-color: #EFEFEF;
        padding: 20px 15px 10px;
        margin-top: 10px;
        .content {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          padding-bottom: 10px;
        }
      }
      .tips {
        margin-top: 10px;
        color: #666;
        font-size: 14px;
        i {
          color: #ffa403;
        }
      }
    }
    .box-footer {
      width: 100%;
      background: #ffffff;
      border-top: 2px solid #eee;
      bottom: 0;
      position: fixed;
      padding: 10px;
      box-sizing: border-box;
      .checkbox {
        align-items: flex-start;
        padding: 5px 1px;
        ::v-deep .van-checkbox__label {
          font-size: 12px;
          font-weight: 500;
          color: #333333;
          line-height: normal;
        }
      }
      .btn {
        background: #cfcfcf;
        box-shadow: 0px 2px 6px 0px rgba(207, 207, 207, 0.5);
        border-radius: 5px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        padding: 14px 0;
        text-align: center;
        border: 1px solid transparent;
      }
      .select-btn {
        background: #0086ff;
        box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
      }
    }
  }
}
</style>